<template>
  <v-sheet v-if="attachments && attachments.length > 0">
    <div v-if="inline">
      <v-subheader> Attachments ({{ attachments.length }} files) </v-subheader>
      <v-slide-group class="mx-4" multiple show-arrows>
        <v-slide-item
          class="mx-1"
          v-for="(img, index) in imageAttachments"
          :key="index + 1"
        >
          <div class="text-center">
            <div class="d-flex" style="min-height: 100px">
              <v-img
                :title="img.originalFileName"
                @click="
                  selectedImg = img;
                  imgDialog = true;
                "
                class="my-auto"
                contain
                max-height="80"
                max-width="150"
                :src="img.path"
              ></v-img>
            </div>
          </div>
        </v-slide-item>
        <v-slide-item
          class="mx-1"
          v-for="(file, index) in fileAttachments"
          :key="`file_${index + 1}`"
        >
          <div class="text-center my-auto">
            <div class="d-flex flex-column" style="min-height: 100px">
              <a
                style="text-decoration: none"
                target="_blank"
                :href="file.path"
              >
                <v-icon class="my-auto" :size="75">{{
                  fileIcon(file.mimeType)
                }}</v-icon>
              </a>
              <div class="text-caption text-weight-light">
                {{ file.originalFileName }}
              </div>
            </div>
          </div>
        </v-slide-item>
      </v-slide-group>
    </div>
    <div v-else>
      <v-btn icon v-bind="$attrs" @click="viewAttachment"
        ><v-icon small>mdi-paperclip</v-icon></v-btn
      >
    </div>

    <v-dialog style="z-index: 1000" v-model="imgDialog">
      <v-card>
        <v-card-title class="justify-space-between">
          <v-btn :key="visibleAttachmentIndex" small v-print="printUrl"> Print </v-btn>
          <v-btn @click="imgDialog = null" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="d-flex">
          <v-carousel
            height="auto"
            v-if="imageAttachments && imageAttachments.length > 0"
            @change="visibleAttachmentIndex = $event"
          >
            <v-carousel-item class="text-center" v-for="(file, i) in imageAttachments" :key="i">
              <!-- <v-img :id="'image-attachment-'+i" contain aspect-ratio="1.7" :src="file.path" /> -->
              <img width="100%" :id="'image-attachment-'+i" contain aspect-ratio="1.7" :src="file.path" />
            </v-carousel-item>
          </v-carousel>
          <div v-else class="text-subtitle-2 font-weight-light">
            No image attachments found
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
import print from "vue-print-nb";

export default {
  directives: {
    print,
  },
  props: {
    value: {
      type: Array,
      required: false,
    },
    inline: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data: () => {
    return {
      attachments: [],
      selectedImg: null,
      imgDialog: null,
      visibleAttachmentIndex: 0
    };
  },
  computed: {
    imageAttachments() {
      let images = [];
      if (this.attachments && this.attachments.length > 0) {
        images = this.attachments.filter((a) =>
          a.mimeType.startsWith("image/")
        );
      }

      return images;
    },
    fileAttachments() {
      let files = [];
      if (this.attachments && this.attachments.length > 0) {
        files = this.attachments.filter(
          (a) => !a.mimeType.startsWith("image/")
        );
      }

      return files;
    },
    printUrl(){
      return `image-attachment-${this.visibleAttachmentIndex}`
    },
    printObj(){
      return {
          asyncUrl (reslove, vue) {
            const image = vue.imageAttachments[vue.visibleAttachmentIndex]
            debugger;
            setTimeout(() => {
              reslove(image.path)
            }, 2000)
          },
          preview: false,
          previewTitle: 'test', // The title of the preview window. The default is 打印预览
          // previewBeforeOpenCallback (vue) {
          //   console.log('正在加载预览窗口')
          // },
          // previewOpenCallback (vue) {
          //   console.log('已经加载完预览窗口')
          // },
          // beforeOpenCallback (vue) {
          //   console.log('打开之前')
          // },
          // openCallback (vue) {
          //   console.log('执行了打印')
          // },
          // closeCallback (vue) {
          //   console.log('关闭了打印工具')
          // }
      }
    }
  },
  created() {
    this.attachments = this.value;
  },
  methods: {
    fileIcon(type) {
      if (type === "application/pdf") {
        return "mdi-file-pdf-box";
      }
      if (
        type === "application/csv" ||
        type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        return "mdi-microsoft-excel";
      } else if (type && type.startsWith("video/")) {
        return "mdi-video-outline";
      } else if (type && type.startsWith("audio/")) {
        return "mdi-volume-medium";
      } else {
        console.log(type);
        return "mdi-attachment";
      }
    },
    viewAttachment() {
      if (this.imageAttachments && this.imageAttachments.length > 0) {
        this.imgDialog = true;
      } else if (this.fileAttachments && this.fileAttachments.length > 0) {
        const href = this.fileAttachments[0].path;
        window.open(href, "_blank");
      }
    },
  },
};
</script>

<style></style>
